/**
 * Checks whether a number has no fractional part.
 *
 * @param x - The number to inspect.
 * @returns `true` when the number is a whole number.
 */
export const isWholeNumber = (x: number): boolean => x % 1 === 0;
